/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
  whenHasPermission,
} from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { ContactDetailsCityCounty } from '../../resources/model/contact-details-city-county.model';
import {
  ContactDetailsSharedCommunicationListFormState,
  ContactDetailsSharedCommunicationListFormStateFactory,
} from '../contact-details-shared-communication-list-tab/contact-details-shared-communication-list-form.service';
import {
  ContactDetailsSharedCustomFieldsFormState,
  ContactDetailsSharedCustomFieldsFormStateFactory,
} from '../contact-details-shared-custom-fields-tab/contact-details-shared-custom-fields-form.service';

@Injectable()
export class ContactDetailsCityCountyFormState extends FormState<ContactDetailsCityCounty> {
  customFieldsForm: ContactDetailsSharedCustomFieldsFormState;
  communicationForm: ContactDetailsSharedCommunicationListFormState;

  constructor(schemaFactory: BuilderFormSchemaFactory,
              customFieldsFormFactory: ContactDetailsSharedCustomFieldsFormStateFactory,
              communicationFormFactory: ContactDetailsSharedCommunicationListFormStateFactory) {
    super(schemaFactory);

    this.customFieldsForm = customFieldsFormFactory.create();
    this.communicationForm = communicationFormFactory.create();
  }

  build(cityCounty: ContactDetailsCityCounty): void {
    this.communicationForm.build(cityCounty.communication);
    this.customFieldsForm.build(cityCounty.customFields);

    this.initSchema(cityCounty);

    this.setChildForm('communication', this.communicationForm);
    this.setChildForm('customFields', this.customFieldsForm);
  }

  protected buildSchema(_: ContactDetailsCityCounty, { root, native }: FormStateSchema): FormRootSchema {
    return root({
      enabled: whenHasPermission(BuilderPermission.Contacts.CityCounty.CREATE_EDIT),
      children: {
        customFields: native(this.customFieldsForm.group),
        communication: native(this.communicationForm.group),
      },
    });
  }
}
